<template>
<div style="margin-bottom: 10%">
 <breadcrumb v-bind:path2="path2"></breadcrumb>
  <div class="account">
    <div class="main-content">
      <!-- not login  -->
      <div v-show="loggedIn===false" class="page-width">
        <div class="empty-page-content text-center">
          <h1>{{ $t('pageNotFound') }}</h1>
          <p>{{ $t('doesNotExist') }}</p>
          <p>
            <a href="/" class="btn btn--has-icon-after">
              {{ $t('continueShopping') }}
              <svg aria-hidden="true" focusable="false" role="presentation" class="icon" viewBox="0 0 20 8">
                <path d="M15.186.445c.865.944 1.614 1.662 2.246 2.154.631.491 1.227.857 1.787 1.098v.44a9.933 9.933 0 0 0-1.875 1.196c-.606.485-1.328 1.196-2.168 2.134h-.752c.612-1.309 1.253-2.315 1.924-3.018H.77v-.986h15.577c-.495-.632-.84-1.1-1.035-1.406-.196-.306-.486-.843-.87-1.612h.743z" fill="#00000" fill-rule="evenodd"></path>
              </svg>
            </a>
          </p>
        </div>
      </div>
      <!-- login  -->
      <div v-show="loggedIn===true" class="page-width customers_acc">
        <div class="section-header text-center">
          <h1>{{ $t('myAccount') }}</h1>
          <p @click="signOut(1)">{{ $t('logOut') }}</p>
        </div>
        <div class="grid">
          <div class="grid__item medium-up--two-thirds">
            <h2>{{ $t('orderHistory') }}</h2>
            <p v-show="this.$store.state.orders.orderTimeFrame.length===0">{{ $t('noPlacedOrder') }}</p>
              <!--<span style="margin: 0.2em" v-for="pick1 in picked">
                 <el-radio @change="fetchOrderByMonth($event)" v-model="pick" :label="pick1">
                     {{pick1}}
                 </el-radio>
               </span>-->
               <el-radio-group v-model="pick" @input="fetchOrderByMonth($event)">
                  <el-radio label="3 months"></el-radio>
                  <el-radio label="6 months"></el-radio>
                  <el-radio label="12 months"></el-radio>
                  <el-radio label="all"></el-radio>
               </el-radio-group>
            <table v-show="this.$store.state.orders.orderTimeFrame.length>0" class="responsive-table">
              <thead>
                <tr>
                  <th>{{ $t('orderNo') }}</th>
                  <th>{{ $t('order') }}</th>
                  <th>{{ $t('delivery') }}</th>
                  <th>{{ $t('paymentStatus') }}</th>
                  <th>{{ $t('fulfillmentStatus') }}</th>
                  <th>{{ $t('total') }}</th>
                </tr>
              </thead>
              <tbody>
              <tr v-for="(order, index) in this.$store.state.orders.orderTimeFrame" data-index="index" :key="index">
                <td data-label="Order">
                  <p class="btn" @click="goToOrder(order.SalesOrder_id)">
                    #{{order.SONum}}
                  </p>
                </td>
                <td data-label="Date">{{order.OrderDate}}</td>
                <td data-label="EstDate">{{order.DispatchDate}}</td>
                <td data-label="Payment Status">{{order.PaymentStatus}}</td>
                <td data-label="Fulfillment Status">{{order.SaleStatus}}</td>
                <td data-label="Total">${{order.FinalPrice}}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
          <div class="grid__item medium-up--one-third">
            <h2>{{ $t('accountDetails') }}</h2>
            <p>
              <span>{{defaultAddress.FirstName}} {{defaultAddress.LastName}}</span>
              <br>
              <span>{{defaultAddress.Street}}</span>
              <br>
              <span>{{defaultAddress.City}} {{defaultAddress.State}} {{defaultAddress.zip}}</span>
              <br>
              <span>{{defaultAddress.Country}}</span>
            </p>
            <p class="btn"><router-link to="addresses">{{ $t('viewAddress') }} ({{viewAddresses}})</router-link></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import Router from '../router'
import breadcrumb from '../components/breadcrumb'
import {isUserAuthenticated} from "../store/modules/cart";

export default {
  name: "account",
  components: {
    breadcrumb,
  },
  data(){
    return{
      path2: this.$t('account'),
      errors: [],
      orderTimeFrame:[],
      loaded: false,
      pick: '3 months',
      picked: [
        '3 months',
        '6 months',
        '12 months',
        'all'
      ]
    }
  },
  methods:{
    ...mapMutations('auth', ['logout', 'updateLoginStatus']),
    ...mapActions('orders', ['fetchOrderByTimeFrame','fetchOrderDetails','cancelOrder','fetchConsolidatedOrders']),
    goToOrder(id) {
      this.$router.push({name: 'order', params: {order_id: id}});
    },
    signOut() {
      this.logout();
    },
    fetchOrderByMonth(event){
      if(event==='3 months'){
        this.$store.dispatch('orders/fetchOrderByTimeFrame', 3);
      }
      if(event==='6 months'){
        this.$store.dispatch('orders/fetchOrderByTimeFrame', 6);
      }
      if(event==='12 months'){
        this.$store.dispatch('orders/fetchOrderByTimeFrame', 12);
      }
      if(event==='all'){
        this.$store.dispatch('orders/fetchOrderByTimeFrame', 99);
      }
    },
  },
  mounted() {
    this.$store.dispatch('addresses/fetchAddresses');
    this.$store.dispatch('addresses/fetchDefaultAddress');
    //const month = 3;
    //this.$store.dispatch('orders/fetchOrderByTimeFrame',month);
  },
  computed: mapState({
    loggedIn: state => state.auth.loggedIn,
    viewAddresses: state => state.addresses.customerDetails.length,
    defaultAddress: state => state.addresses.defaultAddress,
  }),
  watch: {
    '$store.state.orders.orderTimeFrame': {
      immidiate: true,
      handler(newval) {
        this.loaded = true;
      }
    }
  }
}
</script>

<style scoped lang="less">
@import "../assets/css/public.less";
@import "../assets/css/account.less";
</style>



// WEBPACK FOOTER //
// src/view/account.vue